import { css } from '@/styled-system/css';

export const addressInputContainerStyles = css.raw({
  paddingBottom: '200',
  display: 'flex',
  flexDirection: { base: 'column', md: 'row' },
  justifyContent: 'space-between',
});

export const disclaimerStyles = css.raw({
  float: 'left',
  fontSize: 'fineprint',
  paddingBottom: '300',
  color: 'inherit',
});
